import SwiperCore, {
  Autoplay,
  Keyboard,
  Navigation,
  Pagination,
  Thumbs,
} from "swiper";

SwiperCore.use([Navigation, Pagination, Keyboard, Autoplay, Thumbs]);
